import {useEffect, useRef, useState} from 'react';
import {dataPurchaseType} from "../../data";
import Popup from "../../../../../../shared/Popup";
import DropDownPurchase from "../../../../../../shared/DropDowns/DropDownPurchase";
import axios from "axios";
import 'rsuite/useToaster/styles/index.css';
import 'rsuite/Message/styles/index.css';
import {useUserStore} from "../../../../../../../modules/shop/user/store";
import Toaster from "../../../../../../shared/Toaster";
import CardProductPersonal from "../CardProductPersonal/CardProductPersonal";
import CardProduct from "../CardProduct/CardProduct";
import {PATHS_API} from "../../../../../../../enum";
import {ToasterProps} from "../../../../../../shared/Toaster/Toaster";
import {getCurrentDateInSeconds} from "../../../../../../shared/functions/getRandomId";
import CountUp from 'react-countup';
import ButtonLabel from "../../../../../../shared/ButtonLoader/ButtonLoader";
import ProductImage from "../../../../../../shared/ProductImage/ProductImage";
import {useI18n} from "../../../../../../i18n/I18nProvider";
import {validateSteamId} from "../../../../../../shared/functions/validateSteamId";

const Product = ({ data, servers, personal, index }: { data: any, servers: any, personal?: any, index?: number }) => {
    const { t, tr } = useI18n()
    const [activePopup, setActivePopup] = useState(false)
    const [confirmActivePopup, setConfirmActivePopup] = useState(false)
    const [quantity, setQuantity] = useState(data.count)
    const user = useUserStore(store => store.user)
    const fetchUser = useUserStore(store => store.fetchUser)

    const [activeServer, setActiveServer] = useState({_id: 0, name: "Сервер"});
    const [activeTypePurchase, setActiveTypePurchase] = useState(dataPurchaseType[0])

    // Получить список серверов и отфильтровать лишние
    const filterServers = servers.filter((server) => {
        return !data.servers.includes(server._id);
    });

    // якщо для товару доступний лише один сервер, обираємо його одразу
    useEffect(() => {
        if (filterServers.length === 1 && activeServer._id !== filterServers[0]._id) {
            setActiveServer(filterServers[0]);
        }
    }, [filterServers.length, filterServers[0]?._id]);

    useEffect(() => {
        setQuantity(data.count);
    }, [data.count]);

    //Количество товара за раз
    const funcMinus = () => setQuantity(quantity > data.count ? quantity - data.count : quantity)
    const funcPlus = () => setQuantity(quantity + data.count)


    //Переход к подтверждению покупки
    const funcConfirm = () => {
        if(!activeServer._id) {
            // попап лишаємо відкритим, щоб гравець одразу обрав сервер
            return setToastProps({ message: t("product.noServer"), type: "warning", id: getCurrentDateInSeconds() });
        }

        // покупка для друга: SteamID має бути заповнений і складатися з 17 цифр, попап лишаємо відкритим
        if(activeTypePurchase.id !== "self") {
            if(friendSteamId.trim() === "") {
                return setToastProps({ message: t("product.noFriend"), type: "warning", id: getCurrentDateInSeconds() });
            }
            if(!validateSteamId(friendSteamId)) {
                return setToastProps({ message: t("product.badSteamId"), type: "warning", id: getCurrentDateInSeconds() });
            }
        }

        if(activeServer._id) {
            setActivePopup(false)
            setConfirmActivePopup(true)
        }
    }

    //Покупка товара
    const [friendSteamId, setFriendSteamId] = useState("")
    const ownerProductId = activeTypePurchase.id === "self" ? user.steamId : friendSteamId.trim()
    const [isLoading, setIsLoading] = useState(false);

    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);

    const handleBuyProduct = async () => {
        // Проверка наличия SteamId друга
        if (isLoading) return; // предотвращает повторные клики

        // перевірку робимо до setIsLoading, інакше кнопка лишалась би заблокованою після помилки
        if (ownerProductId !== user.steamId && !validateSteamId(ownerProductId)) {
            setToastProps({ message: ownerProductId === "" ? t("product.noFriend") : t("product.badSteamId"), type: "error", id: getCurrentDateInSeconds() });
            setConfirmActivePopup(false);
            return; // Прерываем выполнение
        }

        setIsLoading(true);

        try {
            // Отправка запроса на сервер для покупки
            const response = await axios.post(`${PATHS_API.PURCHASES}/${ownerProductId}`, {
                productId: data._id,
                server: activeServer,
                quantity: quantity / data.count,
            }, {
                withCredentials: true,
            });

            // Если покупка успешна, показываем сообщение и обновляем данные пользователя
            setToastProps({ message: response.data.message, type: response.data.statusCode === 201 ? "success" : "error", id: getCurrentDateInSeconds() });
            fetchUser();
        } catch (error) {
            // В случае ошибки показываем сообщение об ошибке
            const errorMessage = error.response?.data?.message || t("product.error");
            setToastProps({ message: errorMessage, type: "error", id: getCurrentDateInSeconds()});
        } finally {
            // Закрытие попапа после выполнения запроса
            setConfirmActivePopup(false);
            setIsLoading(false);
        }
    };



    //Всё для анимации
    const newPrice = data.price / data.count * quantity;
    const previousPrice = useRef(newPrice);

    const startValue = previousPrice.current;
    previousPrice.current = newPrice; // сразу обновляем, но стартуем с предыдущего


    return (
        <>
            <div
                onClick={() => setActivePopup(true)}
                className={personal ? "product-personal" : "product"}
                style={index !== undefined ? ({ "--i": Math.min(index, 14) } as React.CSSProperties) : undefined}
            >
                { personal
                    ? <CardProductPersonal data={data} />
                    : <CardProduct data={data} />
                }
            </div>
            <Popup title={data.name} activePopup={activePopup} setActivePopup={setActivePopup}>
                <div className="wrapper-desc">
                    <div className="purchase-info">
                        <div className="product-desc-img-wrapper">
                            <ProductImage className="product-desc-img" src={data.imageUrl} alt="product-img"/>
                            { data.discount && <span className="discount-desc-info">-{ data.discount * 100 }%</span> }
                        </div>
                        <p className="desc-product">
                            {data.description}
                        </p>
                        <div className="quantity-block">
                            <div className="quantity-btn-block">
                                <button
                                    className="quantity-btn"
                                    onClick={funcMinus}
                                >
                                    -
                                </button>
                                { quantity }
                                <button
                                    className="quantity-btn"
                                    onClick={funcPlus}
                                >
                                    +
                                </button>
                            </div>
                            <div className="price-desc">
                                {/*UAH <span>{data.price / data.count * quantity}</span>*/}
                                UAH <CountUp
                                duration={1}
                                start={startValue}
                                end={newPrice}
                            />
                            </div>
                        </div>
                        <div className="details-purchase">
                            <DropDownPurchase
                                data={filterServers}
                                activeOption={activeServer}
                                setActiveOption={setActiveServer}
                                width={"135px"}
                            />
                            <div className="wrapper-type-purchase">
                                <DropDownPurchase
                                    data={dataPurchaseType}
                                    activeOption={activeTypePurchase}
                                    setActiveOption={setActiveTypePurchase}
                                    width={"205px"}
                                />
                                { activeTypePurchase.id !== "self" && <input style={{outline: "none", color: "var(--main-text-color)"}} value={friendSteamId} onChange={(e) => {setFriendSteamId(e.target.value)}} placeholder={t("product.friendPlaceholder")} type="number"/> }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    user.steamId
                        ? <button onClick={funcConfirm} className="button-buy">{t("product.buy")}</button>
                        : <button
                            onClick={() => window.location.href = PATHS_API.LOGIN}
                            className="button-buy"
                        >
                            {t("product.loginSteam")}
                        </button>
                }
            </Popup>
            {/*<Popup title={"🤔"} activePopup={confirmActivePopup} setActivePopup={setConfirmActivePopup} positionCenter>*/}
            {/*    <div className="modal-confirm">*/}
            {/*        Ви точно хочете придбати*/}
            {/*        <strong> {data.name} (x{quantity})</strong>*/}
            {/*        <br/> на сервер*/}
            {/*        <strong> { activeServer.name }</strong> ?*/}
            {/*    </div>*/}
            {/*    <div className="info-pickup">*/}
            {/*        Після придбання можете забрати на клавішу <strong>"u"</strong>*/}
            {/*    </div>*/}
            {/*    <div className="modal-confirm-wrapper-btn">*/}
            {/*        <button disabled={isLoading} onClick={handleBuyProduct} className="button-buy">{ isLoading ? "Очікування відповіді..." : "Так" }</button>*/}
            {/*        <button onClick={() => setConfirmActivePopup(false)} className="button-buy button-secondary">Скасувати</button>*/}
            {/*    </div>*/}
            {/*</Popup>*/}

            <Popup title={"🤔"} activePopup={confirmActivePopup} setActivePopup={setConfirmActivePopup} positionCenter>
                <div className="modal-confirm">
                    {t("product.confirmBefore")}
                    <strong> {data.name} (x{quantity})</strong>
                    <br/> {t("product.confirmOnServer")}
                    <strong> { tr(activeServer.name) }</strong> ?
                </div>
                <div className="info-pickup">
                    <span dangerouslySetInnerHTML={{ __html: t("product.pickup").replace("<b>", "<strong>").replace("</b>", "</strong>") }} />
                </div>
                <div className="modal-confirm-wrapper-btn">
                    <button disabled={isLoading} onClick={handleBuyProduct} className={`button-buy ${isLoading ? "btn-loading" : ""}`}><ButtonLabel loading={isLoading}>{t("product.yes")}</ButtonLabel></button>
                    <button onClick={() => setConfirmActivePopup(false)} className="button-secondary">{t("product.cancel")}</button>
                </div>
            </Popup>
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </>
    );
};

export default Product;